module.exports = __webpack_public_path__ + "static/img/cabinet24_10.3b092c98.gif";